import { render, staticRenderFns } from "./PageBody.vue?vue&type=template&id=1272ca57&"
import script from "./PageBody.vue?vue&type=script&lang=js&"
export * from "./PageBody.vue?vue&type=script&lang=js&"
import style0 from "./PageBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PageBody.vue"
export default component.exports